/**
 * withBhk — prefix a villa display string with its BHK (e.g. "3BHK Artistic Villa – Garden Escape").
 * Safe to call with partial data. Returns name unchanged if bedrooms is missing.
 */
export const withBhk = (villa, nameOverride) => {
  const name = nameOverride ?? villa?.name ?? '';
  const beds = villa?.bedrooms;
  if (!beds || !name) return name;
  // Don't double-prefix if the name already starts with "<n>BHK"
  if (/^\s*\d+BHK\b/i.test(name)) return name;
  return `${beds}BHK ${name}`;
};

/** Short BHK badge, e.g. "3BHK". */
export const bhkBadge = (villa) => (villa?.bedrooms ? `${villa.bedrooms}BHK` : '');
